import React from "react";
import {
  CAT_META,
  DEFAULT_CAT_META,
  actionTone,
  formatDate,
  formatTime,
  stripCatPrefix
} from "./user-monitor-utils";
import "./user-monitor-card.css";

/**
 * Карточка записи журнала действий пользователей — одна в ряд.
 */
const UserMonitorCard = ({ record, catLabel, vidLabel, selected, onSelect }) => {
  const meta = CAT_META[record.idCat] || DEFAULT_CAT_META;
  const Icon = meta.icon;
  const tone = actionTone(record.vid, vidLabel);
  const title = stripCatPrefix(vidLabel) || vidLabel || "";
  const hasObj = Boolean(record.objZagName || record.objCntName);
  const initial = (record.userName || "").trim().charAt(0).toUpperCase();
  const date = formatDate(record.fdatetime || record.fdate);
  const time = formatTime(record.fdatetime);

  const select = () => onSelect?.(record);

  return (
    <article
      className={["user-monitor-card", selected ? "is-selected" : ""]
        .filter(Boolean)
        .join(" ")}
      data-tone={tone}
      data-cat={record.idCat}
      onClick={select}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          select();
        }
      }}
    >
      <span className="user-monitor-card__icon">
        <Icon />
      </span>

      <div className="user-monitor-card__main">
        <div className="user-monitor-card__top">
          <span className="user-monitor-card__title" title={vidLabel}>
            {title}
          </span>
          {catLabel ? <span className="user-monitor-card__cat">{catLabel}</span> : null}
        </div>
        {hasObj ? (
          <div className="user-monitor-card__obj">
            {record.objZagName ? (
              <span className="user-monitor-card__obj-zag">{record.objZagName}</span>
            ) : null}
            {record.objCntName ? (
              <span className="user-monitor-card__obj-cnt">
                {record.objZagName ? ` · ${record.objCntName}` : record.objCntName}
              </span>
            ) : null}
          </div>
        ) : null}
        {record.komment ? (
          <div className="user-monitor-card__komment" title={record.komment}>
            {record.komment}
          </div>
        ) : null}
      </div>

      <div className="user-monitor-card__side">
        <span className="user-monitor-card__when">
          {date ? <span className="user-monitor-card__date">{date}</span> : null}
          {time ? <span className="user-monitor-card__time">{time}</span> : null}
        </span>
        {record.userName ? (
          <span className="user-monitor-card__user" title={record.userName}>
            <span className="user-monitor-card__user-initial">{initial}</span>
            <span className="user-monitor-card__user-name">{record.userName}</span>
          </span>
        ) : null}
        {record.idReg != null ? (
          <span className="user-monitor-card__id">#{record.idReg}</span>
        ) : null}
      </div>
    </article>
  );
};

export default UserMonitorCard;
